<mobi-breadcrumb />
<mobi-hero-text
  [superTitle]="entity().superTitle"
  [title]="entity().title"
  [lead]="entity().lead"
  [subtitle]="entity().subtitle"
  [contentLinks]="contentLinks()"
  [primaryCta]="entity().cta | extractUrl"
  [primaryCtaTitle]="entity().cta?.title"
  [primaryCtaIcon]="entity().ctaIcon"
/>

@if (entity().headerImage) {
  <div class="mobi-ui-grid is-centered mobi-ui-margin-t-lg">
    <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
      <div class="hero-image-animation-wrapper">
        @defer (hydrate never) {
          <mobi-media
            [animation]="false"
            class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
            rounded="none"
            [entity]="entity().headerImage"
            responsiveStyle="full_width"
            [lazy]="false"
          />
        }
      </div>
    </div>
  </div>
}

<div class="page-content">
  @if (entity().paragraphs) {
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      }
    }
  }
  @defer (hydrate on viewport) {
    @if (entity().relatedContent?.length) {
      <div class="content-section is-background">
        <div>
          <mobi-related-content
            [teasers]="entity().relatedContent!"
            [title]="entity().relatedContentTitle"
            [description]="entity().relatedContentText"
          />
        </div>
      </div>
    }
  }
</div>
